"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import * as gtag from "@/lib/gtag";
export default function AnalyticsProvider() {
  const $ = _c(3);
  const pathname = usePathname();
  let t0;
  let t1;
  if ($[0] !== pathname) {
    t0 = () => {
      if (!pathname) {
        return;
      }
      gtag.pageview(pathname);
    };
    t1 = [pathname];
    $[0] = pathname;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}